<template>
  <li :class="liClass">
    <div class="dt">
      <div class="num">{{item.index}}</div>
      <div class="title" @click.prevent="goView">{{item.title}}</div>
      <div class="apply" v-if="hasAttachment">
        <a href @click.prevent="togglePanel">
          <img src="@/assets/img/apply.png" alt />자료 신청
        </a>
        <img src="@/assets/img/share_arrow.png" alt class="arrow" />
      </div>
    </div>
    <div class="dd" v-if="showPanel">
      <p>공유 받을 이메일 주소를 입력하세요.</p>
      <div class="inputWrap">
        <input v-model="mail1" type="text" class="mail1" /> @
        <input v-model="mail2" type="text" class="mail2" />
        <a href @click.prevent="requestMail">신청</a>
      </div>
    </div>
  </li>
</template>

<script>
function checkEmail(str) {
  var reg_email = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
  if (!reg_email.test(str)) {
    return false;
  } else {
    return true;
  }
}

export default {
  props: ["item"],
  data() {
    return {
      showPanel: false
    };
  },
  computed: {
    mail1: {
      get() {
        return this.$store.state.mail1;
      },
      set(value) {
        this.$store.state.mail1 = value;
      }
    },
    mail2: {
      get() {
        return this.$store.state.mail2;
      },
      set(value) {
        this.$store.state.mail2 = value;
      }
    },

    hasAttachment() {
      if (
        this.item.Items.length > 0 &&
        this.item.Items[0].mail_attachment != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasSlide() {
      if (
        this.item.Items.length > 0 &&
        this.item.Items[0].jimun_multi !== "[]"
      ) {
        return true;
      } else {
        return false;
      }
    },
    liClass() {
      return this.hasAttachment ? "" : "noApply";
    }
  },
  methods: {
    togglePanel() {
      this.showPanel = !this.showPanel;
    },
    requestMail() {
      //TODO: save email to DB for sending the attachment file

      // let url = "http://next.weliveon.net:1337/api/v1/requestdata";
      let url = `${process.env.VUE_APP_REST_SERVER}/api/v1/requestdata`;
      let classroom_id = localStorage.getItem("clsid");
      let paper_id = this.item.Items[0].paper_id;
      let nick = localStorage.getItem("default_info");
      let email = this.mail1 + "@" + this.mail2;

      let _k = checkEmail(email);
      if (!_k) {
        alert("이메일을 확인해주세요");
        return;
      }

      let $self = this;

      this.$axios
        .post(url, {
          classroom_id: classroom_id,
          paper_id: paper_id,
          default_info: nick,
          email: email,
          status: "Y"
        })
        .then(() => {
          $self.togglePanel();
        });

      // let will_email = `http://next.weliveon.net:1337/api/v1/sendmail/${paper_id}/${email}/M2`;

      let will_email = `${process.env.VUE_APP_REST_SERVER}/api/v1/sendmail/${paper_id}/${email}/M2`;
      this.$axios.get(will_email).then(resp => {
        //todo:  todo something    after send email
        alert("자료메일을 보냈습니다");
      });
    },
    goView() {
      if (this.hasSlide) {
        this.$router.push("/slide/playgroud/" + this.item.Items[0].id);
      } else {
        alert("NONE");
      }
    }
  }
};
</script>


<style lang="scss">
</style>